import { combineReducers } from "redux";
import authUser from "./authUser";
import layout from "./layout";
import navbar from "./navbar";
import deviceUId from "./deviceUId";
import alert from "./alert";
import userAccount from "./userAccount";
import accountFeatures from "./accountFeatures";


export default combineReducers({
    authUser,
    layout,
    navbar,
    deviceUId,
    alert,
    userAccount,
    accountFeatures,
})